var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  };
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React7 from "react";
import PropTypes4 from "prop-types";
import * as React3 from "react";
import * as React from "react";
import { Box } from "@twilio-paste/box";
import PropTypes from "prop-types";
var FauxInputPropTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  element: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  readOnly: PropTypes.bool,
  type: PropTypes.oneOf(["text", "email", "hidden", "number", "password", "search", "tel", "date", "time"]),
  variant: PropTypes.oneOf(["default", "inverse"])
};
var DefaultFauxInput = React.forwardRef((_ref, ref) => {
  let {
    disabled,
    element,
    hasError,
    readOnly,
    children,
    type,
    variant
  } = _ref;
  let backgroundColor = "colorBackgroundBody",
    boxShadow = "shadowBorder",
    boxShadowHover = "shadowBorderPrimaryStronger",
    boxShadowActive = "shadowBorderPrimaryStronger";
  return disabled && type !== "hidden" ? (boxShadow = "shadowBorderWeak", boxShadowHover = "shadowBorderWeak", backgroundColor = "colorBackground", boxShadowActive = "shadowBorderWeak") : readOnly && type !== "hidden" ? (boxShadowHover = "shadowBorder", backgroundColor = "colorBackground") : hasError && type !== "hidden" ? (boxShadow = "shadowBorderError", boxShadowHover = "shadowBorderErrorStronger") : type === "hidden" && (boxShadow = null, boxShadowHover = null, backgroundColor = null, boxShadowActive = null), React.createElement(Box, {
    element,
    ref,
    display: "flex",
    width: "100%",
    backgroundColor,
    boxShadow,
    borderRadius: "borderRadius20",
    transition: "box-shadow 100ms ease-in",
    cursor: disabled ? "not-allowed" : "text",
    variant,
    _hover: {
      boxShadow: boxShadowHover
    },
    _focusWithin: {
      boxShadow: disabled ? boxShadow : "shadowFocus"
    },
    _active: {
      boxShadow: boxShadowActive
    }
  }, children);
});
DefaultFauxInput.displayName = "DefaultFauxInput";
DefaultFauxInput.propTypes = FauxInputPropTypes;
import * as React2 from "react";
import { Box as Box2 } from "@twilio-paste/box";
var InverseFauxInput = React2.forwardRef((_ref2, ref) => {
  let {
    disabled,
    element,
    hasError,
    readOnly,
    children,
    type,
    variant
  } = _ref2;
  let backgroundColor = "colorBackgroundInverse",
    boxShadow = "shadowBorderInverse",
    boxShadowHover = "shadowBorderInverseStrongest";
  return disabled && type !== "hidden" ? (backgroundColor = "colorBackgroundInverse", boxShadow = "shadowBorderInverseWeaker", boxShadowHover = "shadowBorderInverseWeaker") : readOnly && type !== "hidden" ? (backgroundColor = "colorBackgroundInverseStrong", boxShadowHover = "shadowBorderInverse") : hasError && type !== "hidden" ? boxShadow = "shadowBorderErrorWeak" : type === "hidden" && (backgroundColor = null, boxShadow = null, boxShadowHover = null), React2.createElement(Box2, {
    element,
    ref,
    display: "flex",
    width: "100%",
    backgroundColor,
    boxShadow,
    borderRadius: "borderRadius20",
    color: "colorTextInverse",
    transition: "box-shadow 100ms ease-in",
    cursor: disabled ? "not-allowed" : "text",
    variant,
    _hover: {
      boxShadow: boxShadowHover
    },
    _focusWithin: {
      backgroundColor: "colorBackgroundInverse",
      boxShadow: disabled ? boxShadow : "shadowFocusInverse"
    },
    _active: {
      boxShadow: boxShadowHover
    }
  }, children);
});
InverseFauxInput.displayName = "InverseFauxInput";
InverseFauxInput.propTypes = FauxInputPropTypes;
var FauxInputVariants = {
    default: DefaultFauxInput,
    inverse: InverseFauxInput
  },
  FieldWrapper = React3.forwardRef((_ref3, ref) => {
    let {
      children,
      disabled,
      element,
      hasError,
      readOnly,
      type,
      variant = "default"
    } = _ref3;
    let FieldWrapperComponent = FauxInputVariants[variant];
    return React3.createElement(FieldWrapperComponent, {
      disabled,
      element,
      hasError,
      readOnly,
      type,
      variant,
      ref
    }, children);
  });
FieldWrapper.displayName = "FieldWrapper";
FieldWrapper.propTypes = FauxInputPropTypes;
import * as React4 from "react";
import PropTypes2 from "prop-types";
import { Box as Box3 } from "@twilio-paste/box";
var Prefix = React4.forwardRef((_ref4, ref) => {
  let {
    children,
    disabled,
    element = "PREFIX",
    variant
  } = _ref4;
  let backgroundColor = "colorBackground",
    borderColor = "colorBorderWeaker";
  return disabled && variant === "inverse" ? (backgroundColor = "none", borderColor = "colorBorderInverseWeaker") : variant === "inverse" && (backgroundColor = "colorBackgroundInverseStrong", borderColor = "colorBorderInverse"), children == null ? null : React4.createElement(Box3, {
    alignItems: "flex-start",
    backgroundColor,
    borderBottomLeftRadius: "borderRadius20",
    borderRightColor: borderColor,
    borderRightStyle: "solid",
    borderRightWidth: "borderWidth10",
    borderTopLeftRadius: "borderRadius20",
    display: "flex",
    element: "".concat(element, "_PREFIX"),
    lineHeight: "lineHeight20",
    padding: "space30",
    variant,
    ref
  }, children);
});
Prefix.displayName = "Prefix";
Prefix.propTypes = {
  children: PropTypes2.node.isRequired,
  element: PropTypes2.string.isRequired,
  variant: PropTypes2.oneOf(["default", "inverse"])
};
import * as React5 from "react";
import PropTypes3 from "prop-types";
import { Box as Box4 } from "@twilio-paste/box";
var Suffix = React5.forwardRef((_ref5, ref) => {
  let {
    children,
    disabled,
    element = "SUFFIX",
    variant
  } = _ref5;
  let backgroundColor = "colorBackground",
    borderColor = "colorBorderWeaker";
  return disabled && variant === "inverse" ? (backgroundColor = "none", borderColor = "colorBorderInverseWeaker") : variant === "inverse" && (backgroundColor = "colorBackgroundInverseStrong", borderColor = "colorBorderInverse"), children == null ? null : React5.createElement(Box4, {
    alignItems: "flex-start",
    backgroundColor,
    borderBottomRightRadius: "borderRadius20",
    borderLeftColor: borderColor,
    borderLeftStyle: "solid",
    borderLeftWidth: "borderWidth10",
    borderTopRightRadius: "borderRadius20",
    display: "flex",
    element: "".concat(element, "_SUFFIX"),
    lineHeight: "lineHeight20",
    padding: "space30",
    variant,
    ref
  }, children);
});
Suffix.displayName = "Suffix";
Suffix.propTypes = {
  children: PropTypes3.node.isRequired,
  element: PropTypes3.string.isRequired,
  variant: PropTypes3.oneOf(["default", "inverse"])
};
import * as React6 from "react";
var InputBoxContext = React6.createContext(null),
  useInputBoxContext = () => {
    let context = React6.useContext(InputBoxContext);
    if (!context) throw new Error("useInputBoxContext must be used within a <InputBox> component.");
    return context;
  };
var InputBox = React7.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      disabled = !1,
      readOnly = !1,
      element = "INPUT_BOX",
      hasError,
      insertAfter,
      insertBefore,
      type,
      variant = "default"
    } = _b,
    props = __objRest(_b, ["children", "disabled", "readOnly", "element", "hasError", "insertAfter", "insertBefore", "type", "variant"]);
  return React7.createElement(InputBoxContext.Provider, {
    value: {
      disabled,
      readOnly,
      variant
    }
  }, React7.createElement(FieldWrapper, __spreadValues({
    disabled,
    element,
    hasError,
    readOnly,
    type,
    variant,
    ref
  }, props), insertBefore && React7.createElement(Prefix, {
    disabled,
    element,
    variant
  }, insertBefore), children, insertAfter && React7.createElement(Suffix, {
    disabled,
    element,
    variant
  }, insertAfter)));
});
InputBox.displayName = "InputBox";
InputBox.propTypes = {
  children: PropTypes4.node.isRequired,
  element: PropTypes4.string.isRequired,
  disabled: PropTypes4.bool,
  hasError: PropTypes4.bool,
  insertAfter: PropTypes4.node,
  insertBefore: PropTypes4.node,
  readOnly: PropTypes4.bool,
  type: PropTypes4.oneOf(["text", "email", "hidden", "number", "password", "search", "tel", "date", "time"]),
  variant: PropTypes4.oneOf(["default", "inverse"])
};
import * as React8 from "react";
import PropTypes5 from "prop-types";
import { Box as Box5 } from "@twilio-paste/box";
var getChevronWrapperState = (disabled, readOnly) => disabled ? "disabled" : readOnly ? "readOnly" : "default",
  IconColors = {
    default: {
      default: "colorTextIcon",
      disabled: "colorTextWeaker",
      readOnly: "colorTextWeaker"
    },
    inverse: {
      default: "colorTextIconInverse",
      disabled: "colorTextInverseWeaker",
      readOnly: "colorTextInverseWeaker"
    }
  },
  getInputChevronIconColor = function () {
    let variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
    let disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    let readOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    return IconColors[variant][getChevronWrapperState(disabled, readOnly)];
  },
  BackgroundColorStyles = {
    default: {
      default: "colorBackground",
      disabled: "colorBackground",
      readOnly: "colorBackground"
    },
    inverse: {
      default: "colorBackgroundInverseStrong",
      disabled: "colorBackgroundInverse",
      readOnly: "colorBackgroundInverseStrong"
    }
  },
  InputChevronWrapper = React8.forwardRef((_ref6, ref) => {
    let {
      children,
      element = "CHEVRON_WRAPPER"
    } = _ref6;
    let {
      disabled,
      readOnly,
      variant
    } = useInputBoxContext();
    return React8.createElement(Box5, {
      backgroundColor: BackgroundColorStyles[variant][getChevronWrapperState(disabled, readOnly)],
      borderRadius: "borderRadius20",
      cursor: "pointer",
      alignItems: "center",
      display: "inline-flex",
      position: "absolute",
      pointerEvents: "none",
      right: "space30",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: "zIndex10",
      element,
      ref
    }, children);
  });
InputChevronWrapper.displayName = "InputChevronWrapper";
InputChevronWrapper.propTypes = {
  children: PropTypes5.node.isRequired,
  element: PropTypes5.string.isRequired
};
export { InputBox, InputChevronWrapper, Prefix, Suffix, getInputChevronIconColor };